import { useQuery } from "@tanstack/react-query";
import { api, type AuditEvent } from "../api";
import { EmptyState, ErrorNotice, LoadingRows, formatTime } from "../components";

export function AuditPage() {
  const events = useQuery({ queryKey: ["audit-events"], queryFn: () => api<AuditEvent[]>("/admin/v1/audit-events?limit=100") });
  return <div className="page">
    <header className="page-heading"><div><p className="eyebrow">GOVERNANCE / AUDIT</p><h1>操作记录</h1><p>管理写操作以服务端落库结果为准，包含操作者、原因和目标对象。</p></div></header>
    {events.error && <ErrorNotice error={events.error} />}
    {events.isPending ? <LoadingRows columns={5} /> : events.data?.length ? <div className="audit-list">{events.data.map((event) => <article key={event.id}>
      <time>{formatTime(event.created_at)}</time><div><strong>{humanizeAction(event.action)}</strong><p>{event.reason}</p><small>{event.object_type} · {event.object_id}</small></div><div className="audit-list__actor"><strong>{event.actor_subject}</strong><span>{event.actor_role}</span>{event.request_id && <small>Request {event.request_id}</small>}</div>
    </article>)}</div> : <EmptyState title="还没有管理操作">创建配置或轮换 API Key 后，审计事件会显示在这里。</EmptyState>}
  </div>;
}

function humanizeAction(action: string) {
  return action.toLowerCase().split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}
